'use strict';

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol['for'] && Symbol['for']("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

require('./notification.scss');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _cookieWrapper = require('common/utils/cookie-wrapper');

var _cookieWrapper2 = _interopRequireDefault(_cookieWrapper);

var _message = require('./message');

var _message2 = _interopRequireDefault(_message);

var _legacyNotification = require('./legacy-notification');

var _legacyNotification2 = _interopRequireDefault(_legacyNotification);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

module.exports = _react2['default'].createClass({
    displayName: 'NotificationHandler',

    cookie: new _cookieWrapper2['default'](),

    getInitialState: function getInitialState() {
        var notifications = this.cookie.notifications;
        return {
            notifications: notifications,
            siteTransform: 0
        };
    },

    componentDidMount: function componentDidMount() {
        this.cookie.removeNotifications();
        _legacyNotification2['default'].attach();
    },

    renderNotification: function renderNotification(notification, index) {
        var styles = Object.assign({ zIndex: this.state.notifications.length - index }, notification.styles);
        return _react2['default'].createElement(_message2['default'], {
            key: index,
            ref: index,
            notification: notification,
            handleRemove: this.removeNotification.bind(this, index),
            style: styles
        });
    },

    removeNotification: function removeNotification(notificationIndex) {
        var notificationHeight = this.refs[notificationIndex].scrollHeight;
        var siteTransform = this.state.siteTransform + notificationHeight;
        var notifications = this.slideOtherNotifications(notificationIndex, siteTransform);

        this.slideSiteWrapper(siteTransform);

        this.setState({
            siteTransform: siteTransform,
            notifications: notifications
        });
    },

    slideSiteWrapper: function slideSiteWrapper(siteTransform) {
        var siteWrapper = document.getElementById('site-wrapper');
        siteWrapper.style.transform = 'translateY(' + -siteTransform + 'px)';
    },

    slideOtherNotifications: function slideOtherNotifications(notificationIndex, siteTransform) {
        return this.state.notifications.map(function (notification, index) {
            if (index > notificationIndex) {
                notification.styles = {
                    transform: 'translateY(' + -siteTransform + 'px)'
                };
            }
            return notification;
        });
    },

    render: function render() {
        return _jsx('div', {
            className: 'm-notification'
        }, void 0, this.state.notifications.map(this.renderNotification));
    }
});


/*****************
 ** WEBPACK FOOTER
 ** ./src/common/components/notifications/index.jsx
 ** module id = 620
 ** module chunks = 0
 **/